module.exports = __webpack_public_path__ + "static/media/41_A.0c581564.png";